<!-- 作文题 -->
<template>
    <div class="topic_choice">
        <div class="flex topic_select">
            <div class="topic_content scroll_x mar_left_10 flex-1">
                <div class="flex">
                    <div class="mt-8">{{ topicInfo.questionNumber }}.</div>
                    <div class="topic_title" v-html="topicInfo?.questionTitle" v-mathml></div>
                </div>
                <div class="count_num" v-if="getCompositionCount()">{{ `*
                    要求：字数要求为${getCompositionCount()?.minWordCount + '~' + getCompositionCount()?.maxWordCount}字` }}
                </div>
                <!-- <div class="flex Flexalign mt-15" v-if="getAudioUrl(topicInfo.otherRule)">
                    <div class="mr-10">音频：</div><audio :src="getAudioUrl(topicInfo.otherRule)" controls></audio>
                </div> -->
                <div class="answer_box"></div>
            </div>
        </div>
        <div class="topic_answer mt-20">
            <div class="answer_top flex FlexBetween">
                <!-- <div class="flex"> -->
                <div>参考答案：<span class="correct_value_answer" v-html="topicInfo?.questionContext?.answer"
                        v-mathml></span>
                </div>
                <!-- </div> -->
            </div>
            <div class="question_analyze_1">
                <div class="question_analyze mar_top_10">【试题分析】</div>
                <div class="mar_top_10" v-html="$Tools.handlerImg(topicInfo.questionAnalyze)" v-mathml></div>
            </div>
            <div class="question_analyze_2">
                <div class="question_analyze mar_top_10">【解析】</div>
                <div class="mar_top_10" v-html="$Tools.handlerImg(topicInfo.questionExplanation)" v-mathml></div>
            </div>
        </div>
    </div>
</template>

<script>
// import quillEditor from "@/components/quillEditor/index.vue"
import { mapState } from "vuex";
import * as config from "@/config/config";
export default {
    name: "GjkcH5Composition",
    components: {
        // quillEditor
    },
    props: {
        questionInfo: {},
        isShowScoring: {
            default: false
        },
        questionTypeName: {
            default: "作文题"
        },
        testType: {},
        //  用于错题展示隐藏用户答案信息等
        hideUserAnswer: {
            default: false,
        },
        isChallenge: {},
        showAnswer: {}, // 用于测评报告弹题展示解析等
    },
    computed: {
        ...mapState({
            testExamTime: (state) => state.exam.testExamTime,
            testExamInfo: (state) => state.exam.testExamInfo,
        }),
        // 添加计算属性实时转换
        transformedImageList() {
            if (!this.topicInfo.doAnswer?.imageList) return [];
            return this.topicInfo.doAnswer.imageList.map(item => {
                return item.response?.data?.url || item.url;
            });
        }
    },

    data() {
        return {
            topicInfo: {},
            uploadUrl: "",
            activeTab: 'text', // 当前激活的tab
            hasTextContent: false, // 是否有文本内容
            hasImageContent: false, // 是否有图片内容
            previousTab: 'text', // 记录前一个tab
        };
    },
    watch: {
        // 监听计算属性的变化，实时更新到 image
        transformedImageList: {
            handler(newUrls) {
                if (this.topicInfo.doAnswer) {
                    this.topicInfo.doAnswer.image = newUrls;
                }
            },
            immediate: true
        },
        questionInfo: {
            handler(val) {
                if (val) {
                    this.topicInfo = this.questionInfo;
                    // 判断是否回答过
                    if (this.topicInfo.courseExamRecordId) {
                        this.topicInfo.doAnswer = this.topicInfo.questionContext.doAnswer;
                    }
                }
            },
            deep: true,
            immediate: true
        },
    },

    mounted() {
        this.uploadUrl = config.COMMON_UPLOAD_URL;
    },
    beforeUnmount() {
        if (this.recordTimeInterval) {
            clearInterval(this.recordTimeInterval);
            this.recordTimeInterval = null;
        }
    },

    methods: {
        getIsShow(showId) {
            let flag = false;
            if (!this.$Tools.empty(this.testExamInfo.otherRule)) {
                if (!this.$Tools.empty(this.testExamInfo.otherRule.showAnswer)) {
                    if (this.testExamInfo.otherRule.showAnswer.findIndex(item => item == showId) != -1) {
                        flag = true;
                    }
                }
            }
            return flag
        },
        getAudioUrl(info) {
            let ruleInfo = this.$Tools.jsonDecode(info);
            if (!this.$Tools.empty(ruleInfo)) {
                return ruleInfo.listeningRule?.audioUrl
            }
        },
        getCompositionCount() {
            console.log(this.topicInfo.otherRule)
            if (!this.$Tools.empty(this.topicInfo.otherRule)) {
                let ruleInfo = this.$Tools.jsonDecode(this.topicInfo.otherRule);
                // return `${ruleInfo.compositionRule?.minWordCount}~${ruleInfo.compositionRule?.maxWordCount}`
                return {
                    minWordCount: ruleInfo.compositionRule?.minWordCount,
                    maxWordCount: ruleInfo.compositionRule?.maxWordCount,
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.topic_select {
    
    font-size: 12px;
    .topic_type {
        // margin-top: 1rem;
        // width: 45px;
        min-width: 45px;
        padding: 0 8px;
        height: 21px;
        background: rgba(0, 199, 88, 0.2);
        border-radius: 4px;
        border: 1px solid #00c758;
        line-height: 21px;
        text-align: center;
        font-size: 12px;
        color: #00c758;
    }

    .topic_content {

        // overflow-x: auto;
        .topic_title {
            // font-size: 16px;
            color: #242324;
            font-weight: 600;
        }

        .answer_box {
            width: 100%;
            height: 500px;
        }

        .count_num {
            color: #FF8300;
            font-size: 12px;
        }

        :deep(.el-tabs__nav) {
            float: right;
        }

        :deep(.el-tabs__item.is-active) {
            color: #13D6AA;
        }

        .input_title {
            :deep(.el-input__wrapper) {
                box-shadow: 0 0 0 0px var(--el-input-border-color, var(--el-border-color)) inset;
                cursor: default;
                line-height: 60px;
                font-size: 18px;

                .el-input__inner {
                    cursor: default !important;
                    text-align: center;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
                    padding: 10px 0;
                }
            }
        }

        .input_content {
            :deep(.el-textarea__inner) {
                box-shadow: 0 0 0 0px var(--el-input-border-color, var(--el-border-color)) inset;
            }
        }

        // .upload_box {
        :deep(.el-upload--picture-card) {
            width: 96px;
            height: 96px;
        }

        :deep(.el-upload-list--picture-card .el-upload-list__item) {
            width: 96px;
            height: 96px;
        }

        // }
        .upload_tips {
            font-size: 14px;
            color: #CFCFCF;
        }


    }
}

:deep(.el-input__inner) {
    text-align: center;
}

.composition_image {
    width: 96px;
    height: 96px;
    border-radius: 12px;
}

.bottom_box {
    position: absolute;
    left: calc(50% - 60px);
    bottom: 40px;
    text-align: center;

    .btn_view {
        width: 120px;
        height: 42px;
        background: linear-gradient(90deg, #00D5C2, #00D498);
        border-radius: 21px;
        text-align: center;
        line-height: 42px;
        color: #fff;
        font-size: 18px;
    }

    .view_analysis {
        color: #13D6AA;
    }
}

.topic_answer {
    width: 100%;
    font-size: 12px;
    // height: 222px;
    // background: rgba(19, 214, 170, 0.05);
    border-radius: 10px;
    padding: 20px;
    color: #666666;
    box-sizing: border-box;

    .top_answer {
        background: #F8F9FA;
        border-radius: 8px;
        width: 100%;
        box-sizing: border-box;

        .user_answer {
            position: relative;

            .bg_line {
                width: 73px;
                height: 8px;
                background: rgba(19, 214, 170, 0.2);
                position: absolute;
                top: 16px;
                left: 0;
            }
        }
    }

    .answer_top {
        .correct_value_answer {
            color: RGBA(0, 199, 88, 1);
        }

        .error_value_answer {
            color: RGBA(255, 49, 49, 1);
        }

        .btn_ask {
            width: 64px;
            height: 28px;
            background: linear-gradient(90deg, #00d5c2, #00d498);
            border-radius: 14px;
            line-height: 28px;
            text-align: center;
            color: #fff;
        }

        .get_score {
            color: #FD673B;
        }
    }

    .question_analyze {
        color: #333333;
        font-weight: 600;
    }
}

.marker_info {
    width: 100%;
    background: rgba(19, 214, 170, 0.05);
    border-radius: 10px;
    padding: 20px;
    box-sizing: border-box;

    .marker_label {
        font-size: 14px;
        color: #999999;
    }
}
</style>